import React, { useEffect, useState } from 'react';
import { db } from '../auth/UsersConfig/Authfirebase';
import { collection, getDocs, doc, updateDoc } from 'firebase/firestore';
import { Table, Button, Form } from 'react-bootstrap';

const Pedidos = () => {
    const [pedidos, setPedidos] = useState([]);
    const [direcciones, setDirecciones] = useState([]);
    const [filtro, setFiltro] = useState('');

    useEffect(() => {
        const fetchPedidos = async () => {
            const pedidosRef = collection(db, 'pedido');
            const pedidosSnapshot = await getDocs(pedidosRef);
            const pedidosData = pedidosSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setPedidos(pedidosData);
        };

        const fetchDirecciones = async () => {
            const direccionesRef = collection(db, 'direccionPedido');
            const direccionesSnapshot = await getDocs(direccionesRef);
            const direccionesData = direccionesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setDirecciones(direccionesData);
        };

        fetchPedidos();
        fetchDirecciones();
    }, []);

    const getDireccion = (pedidoId) => {
        return direcciones.find(direccion => direccion.pedidoId === pedidoId);
    };

    const marcarComoAtendido = async (pedidoId) => {
        const pedidoRef = doc(db, 'pedido', pedidoId);
        await updateDoc(pedidoRef, { estado: 'atendido' });
        // Actualizar el estado localmente
        setPedidos(pedidos.map(pedido => pedido.id === pedidoId ? { ...pedido, estado: 'atendido' } : pedido));
    };

    const marcarComoPendiente = async (pedidoId) => {
        const pedidoRef = doc(db, 'pedido', pedidoId);
        await updateDoc(pedidoRef, { estado: 'pendiente' });
        // Actualizar el estado localmente
        setPedidos(pedidos.map(pedido => pedido.id === pedidoId ? { ...pedido, estado: 'pendiente' } : pedido));
    };

    const handleFiltroChange = (e) => {
        setFiltro(e.target.value);
    };

    return (
        <div>
            <h2>Pedidos</h2>
            <Form.Select
                value={filtro}
                onChange={handleFiltroChange}
                style={{ marginBottom: '20px' }}
            >
                <option value="">Todos</option>
                <option value="pendiente">Pendiente</option>
                <option value="atendido">Atendido</option>
            </Form.Select>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Items</th>
                        <th>Total</th>
                        <th>Fecha</th>
                        <th>Colonia</th>
                        <th>Dirección</th>
                        <th>Teléfono</th>
                        <th>Estado</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {pedidos.filter(pedido => !filtro || pedido.estado === filtro).map((pedido, index) => {
                        const direccion = getDireccion(pedido.id);
                        return (
                            <tr key={pedido.id}>
                                <td>{index + 1}</td>
                                <td>
                                    {pedido.items.map((item, idx) => (
                                        <div key={idx}>
                                            {item.nombre} - {item.quantity} unidades
                                        </div>
                                    ))}
                                </td>
                                <td>${pedido.total.toFixed(2)}</td>
                                <td>{new Date(pedido.timestamp.seconds * 1000).toLocaleDateString()}</td>
                                <td>{direccion ? direccion.colonia : 'N/A'}</td>
                                <td>{direccion ? direccion.direccion : 'N/A'}</td>
                                <td>{direccion ? direccion.telefono : 'N/A'}</td>
                                <td>{pedido.estado || 'pendiente'}</td>
                                <td>
                                    {pedido.estado === 'pendiente' ? (
                                        <Button variant="success" onClick={() => marcarComoAtendido(pedido.id)}>
                                            Marcar como atendido
                                        </Button>
                                    ) : (
                                        <Button variant="warning" onClick={() => marcarComoPendiente(pedido.id)}>
                                            Marcar como pendiente
                                        </Button>
                                    )}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        </div>
    );
};

export default Pedidos;
